(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["am2-cookie-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const key = 'aftermind_cookie_consent_v1';
    const banner = document.querySelector('[data-am2-cookie-banner]');
    if (!banner) return;

    const applyConsent = (choice) => {
      const granted = choice === 'accepted';
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function(){ window.dataLayer.push(arguments); };
      window.gtag('consent', 'update', {
        ad_storage: granted ? 'granted' : 'denied',
        analytics_storage: granted ? 'granted' : 'denied',
        ad_user_data: granted ? 'granted' : 'denied',
        ad_personalization: granted ? 'granted' : 'denied',
        functionality_storage: 'granted',
        security_storage: 'granted'
      });
      window.dataLayer.push({ event: 'aftermind_cookie_consent', aftermind_consent: choice });
    };

    let choice;
    try { choice = window.localStorage.getItem(key); } catch (error) { choice = null; }
    if (choice === 'accepted' || choice === 'necessary') {
      applyConsent(choice);
      return;
    }

    banner.hidden = false;
    banner.querySelectorAll('[data-am2-cookie-choice]').forEach((button) => {
      button.addEventListener('click', () => {
        choice = button.dataset.am2CookieChoice;
        try { window.localStorage.setItem(key, choice); } catch (error) {}
        applyConsent(choice);
        banner.hidden = true;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
